import React, { useState } from 'react';
import { Card, Input, Button, message, Space, Typography, Alert, Radio } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const WechatSidebarTest: React.FC = () => {
  const [groupId, setGroupId] = useState('');
  const [testType, setTestType] = useState<'simple' | 'case'>('case');
  const navigate = useNavigate();

  const handleTest = () => {
    if (!groupId.trim()) {
      message.warning('请输入群聊ID');
      return;
    }
    
    // 根据测试类型跳转到不同的侧边栏页面
    const url = testType === 'case' 
      ? `/wechat/sidebar/case?group_id=${encodeURIComponent(groupId)}`
      : `/wechat/sidebar?group_id=${encodeURIComponent(groupId)}`;
    
    console.log('跳转到:', url);
    navigate(url);
  };

  return (
    <div style={{ padding: '24px', maxWidth: 800, margin: '0 auto' }}>
      <Card>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <div>
            <Title level={3}>企业微信侧边栏测试工具</Title>
            <Paragraph type="secondary">
              用于测试侧边栏功能，模拟企业微信传递 group_id 参数
            </Paragraph>
          </div>

          <Alert
            message="使用说明"
            description={
              <div>
                <p>1. 从数据库或企业微信群聊中获取 group_id（chat_id）</p>
                <p>2. 选择要测试的侧边栏类型</p>
                <p>3. 输入到下方输入框</p>
                <p>4. 点击"打开侧边栏"按钮测试</p>
                <p>5. 查看浏览器控制台的调试信息</p>
              </div>
            }
            type="info"
            showIcon
          />

          <div>
            <Text strong>侧边栏类型:</Text>
            <Radio.Group 
              value={testType} 
              onChange={(e) => setTestType(e.target.value)}
              style={{ marginTop: 8, display: 'block' }}
            >
              <Space direction="vertical">
                <Radio value="case">案件管理（完整功能，包含案件跟进和基础信息）</Radio>
                <Radio value="simple">简单侧边栏（快速跟进和状态更新）</Radio>
              </Space>
            </Radio.Group>
          </div>

          <div>
            <Text strong>群聊ID (group_id / chat_id):</Text>
            <Input
              placeholder="例如: wrkSFfCgAAXxKRNLtKLfPLRxxx"
              value={groupId}
              onChange={(e) => setGroupId(e.target.value)}
              onPressEnter={handleTest}
              size="large"
              style={{ marginTop: 8 }}
            />
          </div>

          <Button type="primary" size="large" onClick={handleTest} block>
            打开侧边栏
          </Button>

          <Alert
            message="如何获取 group_id？"
            description={
              <div>
                <p><strong>方法1：从数据库查询</strong></p>
                <pre style={{ background: '#f5f5f5', padding: 8, borderRadius: 4 }}>
                  SELECT group_id, group_name FROM wechat_group;
                </pre>
                
                <p style={{ marginTop: 16 }}><strong>方法2：从企业微信管理后台</strong></p>
                <p>客户联系 → 客户群 → 查看群详情 → 复制群ID</p>
                
                <p style={{ marginTop: 16 }}><strong>方法3：使用调试工具</strong></p>
                <p>访问 <a href="/wechat/debug" target="_blank">/wechat/debug</a> 查看所有群聊</p>
              </div>
            }
            type="warning"
            showIcon
          />
        </Space>
      </Card>
    </div>
  );
};

export default WechatSidebarTest;
